const KeenSlider = window.KeenSlider

const { useAutoplay, useInitialised } = window.BAO.Carousel.plugins

class LogoSlider extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2 || this.dataset.enableSlider === 'false') return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        slides: {
          perView: 7,
          spacing: 5,
        },
        breakpoints: {
          '(max-width: 768px)': {
            disabled: true,
          },
        },
      },
      [
        useAutoplay(this.slideSpeed, { pauseOnHover: false }),
        useInitialised(),
      ],
    )
  }
}

if (!customElements.get('logo-slider')) {
  customElements.define('logo-slider', LogoSlider)
}
